import { render } from "./OpeningTimesBlock.vue?vue&type=template&id=bc52fbdc&ts=true"
import script from "./OpeningTimesBlock.vue?vue&type=script&lang=ts"
export * from "./OpeningTimesBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__